// extracted by mini-css-extract-plugin
export default {"root":"AffiliatesPanel_root__qUyBC"};